// CurrencyDescription component translations
export default {
  // Multi-currency canvas description
  multi: {
    description:
      "Multi-currency canvas provides higher flexibility, designed for complex analysis scenarios, supporting simultaneous analysis of multi-chain and multi-currency address and transaction data on the same canvas.",
    supportData: "Supported Data",
    supportDetails:
      "Full currency data for Ethereum and BSC chains, with precise target currency search through token contracts. Tron chain supports TRX and USDT.",
  },

  // Single-currency canvas description
  single: {
    description:
      "Single-currency canvas is convenient and efficient, focusing on single currency analysis on a single chain, supporting one-click Xmind file generation.",
    supportData: "Supported Data",
    supportDetails:
      "Full currency data for Ethereum and BSC chains, with precise target currency search through token contracts. Tron chain supports TRX and USDT. BITCOIN chain only supports BTC.",
  },
};
